'use strict';

import { isFieldEmpty, isValidEmail, displayErrors } from './_helper';
import Loader from '../../../_modules/loader/loader';

let loader = new Loader();

$('#forgot-pwd__link').on('click', function (e){
	let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $.fancybox.open('#forgot-password', {
        autoSize: true,
        closeBtn: true,
        fitToView: true,
        minHeight: isMobileDevice == true ? 300 : 220,
        minWidth: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });
});

$('#nav-forgot-pwd').on('click', function (e){
    let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $('.login').removeClass('expanded').hide();

    $.fancybox.open('#forgot-password', {
        autoSize: true,
        closeBtn: true,
        fitToView: true,
        minHeight: isMobileDevice == true ? 300 : 220,
        minWidth: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });
});

$('.js-reset-pwd').on('click', function (e){
    e.preventDefault();
    let $recaptchaSiteKey = $("#ReCaptchaSiteKey");
    if(typeof grecaptcha !== 'undefined' && grecaptcha.ready != null){
        grecaptcha.ready(function() {
            grecaptcha.execute($recaptchaSiteKey.val(), {action: 'login'}).then(function(token) {
                onResetPwdClick(token);
            });
        });
    } else {
        console.warn("Google recaptcha not found.");
        onResetPwdClick("");
    }
});

let onResetPwdClick = function(token){
    let $email = $('#EmailPwdAddress'),
        $errorContainer = $(this).closest('.server-errors__wrap--submit');

	if (isFieldEmpty($email) || !isValidEmail($email.val())) {
        $email
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        $(this).addClass('error'); 
	}
    else{
        $(this).removeClass('error');
        loader.fadeIn();
        
        let dataParams = $email.val();
            

        $.ajax({
            url: '/api/account/forgotpassword',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();
                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                $('.reset-pwd--requested').hide();

                $('.reset-pwd--sent').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                $('.email').text(dataParams);
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    }
}
